import React from 'react';

function PinkSvg() {
  return (
    <svg
      width="300"
      height="201"
      viewBox="0 0 300 201"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_1495)">
        <path d="M300 0H0V201H300V0Z" fill="#F7CEDC" />
        <path d="M213.555 99.1714H211.238V126.107H213.555V99.1714Z" fill="#FFCEB6" />
        <path
          d="M148.76 128.818L148.02 128.062C144.322 127.772 138.702 126.285 135.143 121.882C134.935 121.625 134.744 121.355 134.572 121.073C134.253 120.559 134.029 119.991 133.91 119.397C133.305 116.221 136.583 113.908 138.127 113.53C140.069 113.06 143.411 113.671 144.758 113.958C145.127 114.037 145.348 114.09 145.348 114.09C145.589 114.108 145.831 114.108 146.071 114.09C146.237 114.08 146.415 114.068 146.605 114.053C146.667 114.053 146.728 114.047 146.792 114.04C146.829 114.04 146.865 114.04 146.903 114.035C147.636 113.983 148.372 113.992 149.103 114.062C149.312 114.084 149.53 114.114 149.754 114.151C149.877 114.173 150 114.198 150.125 114.224C150.227 114.246 150.328 114.27 150.432 114.296C150.509 114.315 150.586 114.336 150.662 114.358C150.819 114.401 150.976 114.447 151.132 114.499C151.139 114.502 151.146 114.504 151.153 114.506C151.226 114.53 151.298 114.554 151.371 114.583V114.579C152.496 114.996 153.539 115.61 154.452 116.391C155.302 117.111 156.238 117.861 157.211 118.608C158.513 119.605 159.881 120.598 161.219 121.501C161.219 121.501 161.704 121.594 162.428 121.686L162.437 121.609V112.661H180.183C183.077 118.822 187.61 130 190.824 138.967C194.166 148.289 204.908 164.574 207.087 170.016C209.68 176.486 209.68 180.09 209.68 180.09H171.514C171.531 178.668 171.381 177.249 171.066 175.862L172.457 169.629C171.377 169.657 169.676 169.629 169.676 169.629V169.635C169.48 169.592 168.507 169.349 164.539 168.313C158.487 166.732 145.363 150.279 145.363 150.279C144.038 149.657 141.714 146.755 140.339 144.932C139.653 144.022 139.235 142.939 139.133 141.804H139.111C139.111 141.804 132.215 141.007 128.511 139.824C128.511 139.824 122.609 138.275 120.964 137.564C120.964 137.564 110.652 133.73 108.046 132.22C105.44 130.71 106.672 124.382 111.888 125.895C114.961 126.784 117.668 127.684 117.793 127.728C118.969 128.574 120.38 129.028 121.827 129.025H129.458C129.458 129.025 138.352 130.966 140.025 131.338L140.242 131.35C140.418 130.541 140.702 129.759 141.085 129.025H148.605L148.76 128.818Z"
          fill="#FFCEB6"
        />
        <path
          d="M207.567 107.784C207.589 107.754 207.61 107.723 207.632 107.695C207.554 108.465 207.264 109.199 206.794 109.813C206.477 110.269 206.02 110.609 205.493 110.781C204.967 110.954 204.398 110.95 203.873 110.771L202.065 113.071L200.039 110.494L201.848 108.194C201.696 107.558 201.685 106.896 201.815 106.255C201.944 105.614 202.212 105.009 202.599 104.482C203.006 103.934 203.601 103.556 204.269 103.421C204.242 103.446 204.218 103.473 204.197 103.502C203.743 104.124 203.499 104.873 203.499 105.643C203.499 106.413 203.743 107.163 204.197 107.785C204.386 108.057 204.637 108.28 204.931 108.434C205.224 108.588 205.551 108.668 205.882 108.668C206.213 108.668 206.54 108.588 206.833 108.434C207.127 108.28 207.378 108.057 207.567 107.784Z"
          fill="#CCEFF6"
        />
        <path
          d="M205.947 117.089C206.317 117.596 206.517 118.208 206.517 118.837C206.517 119.465 206.317 120.077 205.947 120.584C205.792 120.807 205.587 120.989 205.347 121.115C205.107 121.241 204.841 121.306 204.57 121.306C204.299 121.306 204.033 121.241 203.793 121.115C203.553 120.989 203.347 120.807 203.193 120.584C202.824 120.091 202.625 119.492 202.626 118.876L202.602 118.909L200.032 115.647L198.007 113.071L196.198 110.771C195.673 110.951 195.104 110.955 194.576 110.783C194.048 110.61 193.591 110.27 193.273 109.814C192.805 109.199 192.516 108.465 192.438 107.696C192.46 107.724 192.478 107.754 192.503 107.785C192.691 108.058 192.943 108.281 193.237 108.435C193.53 108.589 193.857 108.67 194.188 108.67C194.519 108.67 194.846 108.589 195.139 108.435C195.432 108.281 195.684 108.058 195.873 107.785C196.327 107.163 196.572 106.414 196.572 105.643C196.572 104.873 196.327 104.123 195.873 103.502C195.852 103.474 195.829 103.447 195.805 103.421C196.472 103.557 197.065 103.935 197.469 104.482C197.857 105.009 198.126 105.614 198.256 106.255C198.387 106.896 198.376 107.558 198.225 108.194L200.033 110.494L202.059 113.071L204.625 116.332L204.6 116.366C204.864 116.377 205.123 116.448 205.356 116.573C205.589 116.698 205.791 116.875 205.947 117.089Z"
          fill="#CCEFF6"
        />
        <path
          d="M198.004 113.07L200.033 115.647L199.109 116.822L198.004 113.07Z"
          fill="#006B99"
        />
        <path
          d="M198.004 113.07L199.109 116.822L197.464 118.909L197.436 118.876C197.437 119.492 197.238 120.092 196.868 120.585C196.714 120.808 196.508 120.99 196.268 121.115C196.029 121.241 195.762 121.307 195.492 121.307C195.221 121.307 194.954 121.241 194.715 121.115C194.475 120.99 194.269 120.808 194.115 120.585C193.746 120.077 193.547 119.465 193.547 118.837C193.547 118.209 193.746 117.597 194.115 117.089C194.271 116.875 194.473 116.698 194.707 116.573C194.94 116.447 195.198 116.376 195.462 116.364L195.435 116.33L198.004 113.07Z"
          fill="#CCEFF6"
        />
        <path d="M197.639 44.1323H195.428V69.829H197.639V44.1323Z" fill="#FFCEB6" />
        <path
          d="M187.341 56.5729C187.485 56.7344 187.576 56.9357 187.604 57.1502C187.631 57.3646 187.593 57.5825 187.495 57.7751L187.345 58.0522L185.97 60.5947C186.113 60.9109 186.197 61.2506 186.219 61.5969C186.299 62.8211 185.627 63.8605 184.721 63.9162C183.815 63.9723 183.015 63.0315 182.935 61.8073C182.854 60.5831 183.527 59.5443 184.433 59.488C184.601 59.4764 184.769 59.4992 184.927 59.5553L186.157 57.2867L186.457 56.73C186.491 56.6467 186.545 56.5735 186.615 56.5168C186.685 56.4605 186.767 56.4226 186.856 56.4066C186.944 56.3909 187.035 56.3978 187.12 56.427C187.205 56.4561 187.281 56.5062 187.341 56.5729Z"
          fill="#CCEFF6"
        />
        <path
          d="M180.184 112.661H162.439V79.8223C162.439 79.8223 165.051 80.6247 168.39 86.362C171.729 92.0995 176.983 105.97 179.847 111.947C179.957 112.175 180.072 112.412 180.184 112.661Z"
          fill="#FFCEB6"
        />
        <path
          d="M169.712 169.641L169.676 169.629C169.676 169.629 171.377 169.656 172.457 169.629L171.066 175.862C170.526 172.95 169.715 169.777 169.678 169.632C169.69 169.636 169.701 169.639 169.712 169.641Z"
          fill="#006B99"
        />
        <path
          d="M162.439 112.661V121.603L162.43 121.68C161.706 121.588 161.22 121.495 161.22 121.495C159.882 120.591 158.514 119.598 157.212 118.602L157.255 118.546C157.47 118.039 157.581 117.493 157.581 116.941V112.665L162.439 112.661Z"
          fill="#CCEFF6"
        />
        <path
          d="M157.581 61.0039V56.5828C157.581 55.487 157.146 54.4363 156.373 53.6614C155.599 52.8869 154.551 52.4514 153.457 52.4514H128.997C127.904 52.4514 126.855 52.8869 126.082 53.6614C125.308 54.4363 124.874 55.487 124.874 56.5828V65.5912C124.874 66.1338 124.981 66.671 125.188 67.1723C125.395 67.6735 125.699 68.1287 126.082 68.5126C126.465 68.8961 126.919 69.2004 127.419 69.408C127.92 69.6156 128.456 69.7223 128.997 69.7223H153.455C153.996 69.7223 154.533 69.6156 155.033 69.408C155.533 69.2004 155.988 68.8961 156.371 68.5126C156.753 68.1287 157.057 67.6735 157.264 67.1723C157.472 66.671 157.578 66.1338 157.578 65.5912L157.581 61.0039ZM119.303 87.4473V49.8024C119.304 47.8346 120.084 45.9477 121.473 44.5563C122.861 43.165 124.745 42.3832 126.708 42.3826H127.596C127.596 43.865 128.183 45.2867 129.23 46.3353C130.276 47.3835 131.695 47.9724 133.175 47.9724H147.054C148.533 47.9714 149.952 47.3825 150.999 46.3343C152.046 45.2864 152.634 43.865 152.636 42.3826H155.03C156.003 42.3823 156.967 42.5742 157.865 42.9467C158.764 43.3196 159.581 43.866 160.269 44.5551C160.957 45.2442 161.502 46.0619 161.875 46.9624C162.247 47.8628 162.439 48.8277 162.439 49.8024V112.661H157.581V107.935C157.581 106.839 157.146 105.788 156.373 105.013C155.599 104.239 154.551 103.803 153.457 103.803H128.997C127.904 103.803 126.855 104.239 126.082 105.013C125.308 105.788 124.874 106.839 124.874 107.935V116.941C124.874 118.037 125.308 119.088 126.082 119.862C126.855 120.637 127.904 121.073 128.997 121.073H134.574C134.747 121.355 134.937 121.625 135.145 121.881C138.702 126.284 144.322 127.769 148.022 128.061L148.762 128.818L148.608 129.027H126.708C124.744 129.026 122.86 128.243 121.472 126.851C120.083 125.459 119.303 123.571 119.303 121.603V87.4473ZM124.88 87.4473V91.2663C124.88 92.3617 125.314 93.4128 126.088 94.1873C126.861 94.9622 127.91 95.3974 129.003 95.3974H153.461C154.554 95.3974 155.603 94.9622 156.376 94.1873C157.15 93.4128 157.584 92.3617 157.584 91.2663V82.2598C157.584 81.1643 157.15 80.1133 156.376 79.3387C155.603 78.5638 154.554 78.1286 153.461 78.1286H128.997C127.904 78.1286 126.855 78.5638 126.082 79.3387C125.308 80.1133 124.874 81.1643 124.874 82.2598L124.88 87.4473Z"
          fill="#CCEFF6"
        />
        <path
          d="M157.581 112.661V116.937C157.581 117.489 157.47 118.035 157.255 118.543L157.212 118.598C156.239 117.851 155.303 117.1 154.453 116.381C153.541 115.6 152.498 114.987 151.372 114.569C151.652 114.082 151.816 113.538 151.852 112.977C151.889 112.417 151.796 111.856 151.581 111.337C151.367 110.818 151.035 110.356 150.614 109.986C150.192 109.616 149.691 109.348 149.15 109.202C148.608 109.057 148.041 109.039 147.491 109.148C146.941 109.258 146.424 109.493 145.979 109.835C145.534 110.177 145.174 110.616 144.926 111.12C144.678 111.624 144.549 112.178 144.549 112.74C144.55 113.153 144.621 113.564 144.76 113.954C143.413 113.668 140.071 113.056 138.129 113.527C136.585 113.905 133.307 116.217 133.912 119.394C134.031 119.987 134.255 120.555 134.574 121.069H128.997C127.904 121.069 126.855 120.634 126.082 119.859C125.308 119.085 124.874 118.034 124.874 116.938V107.935C124.874 106.839 125.308 105.788 126.082 105.014C126.855 104.239 127.904 103.803 128.997 103.803H153.455C154.548 103.803 155.597 104.239 156.371 105.014C157.144 105.788 157.578 106.839 157.578 107.935V112.661H157.581Z"
          fill="#CCEFF6"
        />
        <path
          d="M124.874 87.4468V82.2596C124.874 81.1638 125.308 80.1131 126.082 79.3382C126.855 78.5637 127.904 78.1282 128.997 78.1282H153.455C154.548 78.1282 155.597 78.5637 156.371 79.3382C157.144 80.1131 157.578 81.1638 157.578 82.2596V91.2658C157.578 92.3616 157.144 93.4123 156.371 94.1872C155.597 94.9618 154.548 95.3973 153.455 95.3973H128.997C127.904 95.3973 126.855 94.9618 126.082 94.1872C125.308 93.4123 124.874 92.3616 124.874 91.2658V87.4468ZM136.77 87.5266C136.77 86.8028 136.555 86.0952 136.154 85.4932C135.752 84.8914 135.181 84.4224 134.514 84.1457C133.846 83.8686 133.112 83.7962 132.403 83.9378C131.694 84.079 131.043 84.4274 130.532 84.9393C130.021 85.4512 129.673 86.1037 129.532 86.8134C129.391 87.5235 129.463 88.2596 129.74 88.9283C130.016 89.5974 130.484 90.1691 131.085 90.5714C131.686 90.9737 132.392 91.1888 133.115 91.1891C133.595 91.1891 134.07 91.0946 134.514 90.9108C134.958 90.7267 135.361 90.4571 135.701 90.1168C136.04 89.7768 136.31 89.3729 136.494 88.9286C136.677 88.4841 136.772 88.0079 136.772 87.5266H136.77Z"
          fill="#CCEFF6"
        />
        <path
          d="M157.581 61.0037V65.591C157.581 66.1336 157.474 66.6708 157.267 67.1718C157.059 67.673 156.756 68.1286 156.373 68.5121C155.99 68.8959 155.535 69.2002 155.035 69.4078C154.535 69.6154 153.998 69.7222 153.457 69.7222H128.997C128.456 69.7222 127.92 69.6154 127.419 69.4078C126.919 69.2002 126.465 68.8959 126.082 68.5121C125.699 68.1286 125.395 67.673 125.188 67.1718C124.981 66.6708 124.874 66.1336 124.874 65.591V56.5848C124.874 55.489 125.308 54.4383 126.082 53.6634C126.855 52.8886 127.904 52.4534 128.997 52.4534H153.455C154.548 52.4534 155.597 52.8886 156.371 53.6634C157.144 54.4383 157.578 55.489 157.578 56.5848L157.581 61.0037ZM151.86 61.0835C151.86 60.3591 151.645 59.6512 151.243 59.0488C150.842 58.4464 150.271 57.9771 149.603 57.7C148.935 57.4226 148.2 57.3503 147.491 57.4915C146.782 57.6327 146.13 57.9815 145.619 58.4937C145.108 59.0059 144.76 59.6587 144.619 60.3691C144.478 61.0795 144.55 61.8158 144.827 62.4849C145.103 63.1543 145.572 63.7263 146.173 64.1286C146.774 64.5309 147.481 64.7457 148.204 64.7457C149.173 64.7451 150.102 64.359 150.787 63.6721C151.473 62.9855 151.858 62.0544 151.858 61.0835H151.86Z"
          fill="#CCEFF6"
        />
        <path
          d="M127.595 42.3826H152.636C152.634 43.865 152.046 45.2864 150.999 46.3343C149.952 47.3825 148.533 47.9714 147.054 47.9724H133.175C131.695 47.9724 130.276 47.3835 129.229 46.3353C128.183 45.2867 127.595 43.865 127.595 42.3826Z"
          fill="#006B99"
        />
        <path
          d="M151.858 112.741C151.857 113.383 151.689 114.013 151.371 114.57L151.149 114.498C151.142 114.496 151.134 114.494 151.127 114.491C150.971 114.436 150.815 114.39 150.658 114.35C150.581 114.328 150.505 114.307 150.428 114.288C150.324 114.261 150.222 114.239 150.121 114.216C149.995 114.192 149.872 114.167 149.75 114.143C149.529 114.104 149.316 114.076 149.099 114.054C148.368 113.983 147.632 113.974 146.899 114.027C146.862 114.027 146.827 114.032 146.788 114.032C146.724 114.039 146.662 114.042 146.601 114.045C146.408 114.057 146.23 114.069 146.067 114.082C145.826 114.1 145.584 114.1 145.343 114.082C145.343 114.082 145.127 114.03 144.754 113.95C144.615 113.56 144.543 113.149 144.543 112.735C144.536 112.25 144.625 111.768 144.806 111.318C144.987 110.867 145.255 110.458 145.595 110.112C145.935 109.767 146.34 109.492 146.787 109.305C147.234 109.118 147.713 109.021 148.198 109.021C148.682 109.021 149.162 109.118 149.609 109.305C150.056 109.492 150.461 109.767 150.801 110.112C151.141 110.458 151.409 110.867 151.59 111.318C151.77 111.768 151.86 112.25 151.853 112.735L151.858 112.741Z"
          fill="white"
        />
        <path
          d="M148.204 64.7461C150.223 64.7461 151.86 63.1061 151.86 61.0836C151.86 59.0611 150.223 57.4211 148.204 57.4211C146.185 57.4211 144.548 59.0611 144.548 61.0836C144.548 63.1061 146.185 64.7461 148.204 64.7461Z"
          fill="white"
        />
        <path
          d="M129.458 129.025H141.087C140.703 129.759 140.42 130.541 140.243 131.35L140.026 131.338C138.352 130.966 129.458 129.025 129.458 129.025Z"
          fill="#006B99"
        />
        <path
          d="M133.117 83.8652C133.84 83.8646 134.547 84.0791 135.148 84.4811C135.75 84.8831 136.219 85.4551 136.496 86.1241C136.773 86.7935 136.846 87.5299 136.705 88.2406C136.564 88.9513 136.217 89.6041 135.705 90.1166C135.194 90.6288 134.542 90.9779 133.833 91.1194C133.124 91.2609 132.389 91.1886 131.721 90.9112C131.053 90.6341 130.482 90.1645 130.08 89.5621C129.678 88.9597 129.464 88.2512 129.464 87.5267C129.464 86.5562 129.849 85.6254 130.534 84.9388C131.219 84.2522 132.148 83.8662 133.117 83.8652Z"
          fill="white"
        />
        <path
          d="M124.56 42.3826H126.708C124.745 42.3832 122.861 43.165 121.473 44.5563C120.084 45.9477 119.304 47.8346 119.303 49.8024V87.4473H117.155V49.8024C117.155 47.8346 117.935 45.9477 119.324 44.5563C120.713 43.165 122.596 42.3832 124.56 42.3826Z"
          fill="#006B99"
        />
        <path
          d="M126.708 129.025H124.56C122.595 129.025 120.711 128.243 119.321 126.851C117.932 125.459 117.151 123.572 117.151 121.603V87.4473H119.303V121.603C119.304 123.571 120.084 125.458 121.472 126.85C122.861 128.242 124.744 129.024 126.708 129.025Z"
          fill="#006B99"
        />
        <path
          d="M114.898 108.372V117.765C114.898 117.765 111.55 117.19 106.996 116.431C102.442 115.671 102.438 110.197 104.872 108.372C107.305 106.546 114.585 108.372 114.585 108.372H114.898Z"
          fill="#FFCEB6"
        />
        <path
          d="M100.615 84.3629V89.3012H99.1259C98.5769 89.3012 98.3006 90.1374 98.6919 90.6296L99.7447 91.9552L96.97 95.448L95.9163 94.1224C95.5263 93.6308 94.8634 93.9774 94.8634 94.6703V96.5453H90.9381V94.6703C90.9381 93.9781 90.2747 93.6308 89.8847 94.1224L88.8322 95.448L86.0578 91.9552L87.1103 90.6296C87.5003 90.1374 87.2241 89.3012 86.6763 89.3012H85.1859V84.3629H86.6763C87.2253 84.3629 87.5019 83.5239 87.1103 83.0345L86.0578 81.7067L88.8322 78.2139L89.8847 79.5389C90.2747 80.028 90.9381 79.6839 90.9381 78.9888V77.116H94.8634V78.9917C94.8634 79.6861 95.5263 80.0311 95.9163 79.5417L96.9688 78.2168L99.7431 81.7067L98.6906 83.0317C98.3006 83.5207 98.5769 84.3601 99.1247 84.3601L100.615 84.3629ZM95.2281 86.8325C95.2281 85.2117 94.185 83.8986 92.9022 83.8986C91.6197 83.8986 90.5728 85.2117 90.5728 86.8325C90.5728 88.4531 91.6159 89.7627 92.9022 89.7627C94.1884 89.7627 95.2281 88.4471 95.2281 86.8325Z"
          fill="#CCEFF6"
        />
        <path d="M80.8991 72.8174H78.3822V102.078H80.8991V72.8174Z" fill="#FFCEB6" />
        <path
          d="M80.8991 72.8174L105.534 74.9698V99.9251L80.8991 102.078"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M80.8991 72.8174H78.3822V102.078H80.8991V72.8174Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M195.428 44.1323L173.795 48.7904V72.2454L195.428 69.8284"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M197.639 44.1323H195.428V69.829H197.639V44.1323Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M211.238 99.1714L188.557 101.152V124.124L211.238 126.108"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M213.555 99.1714H211.238V126.107H213.555V99.1714Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.636 42.3826H155.03C156.003 42.3823 156.967 42.5742 157.865 42.9467C158.764 43.3196 159.581 43.866 160.269 44.5551C160.957 45.2442 161.502 46.0619 161.875 46.9624C162.247 47.8628 162.439 48.8277 162.439 49.8024V121.603"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.203 42.3826H127.595"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M124.56 129.025C122.595 129.025 120.711 128.243 119.321 126.851C117.932 125.459 117.151 123.572 117.151 121.603V49.8024C117.151 48.8277 117.343 47.8628 117.715 46.9624C118.088 46.0619 118.633 45.2442 119.322 44.5551C120.009 43.866 120.826 43.3196 121.725 42.9467C122.624 42.5742 123.587 42.3823 124.56 42.3826"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M148.606 129.025H141.087H129.458H127.203"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M126.708 129.025C124.744 129.024 122.861 128.242 121.472 126.85C120.084 125.458 119.304 123.571 119.303 121.603V49.8024C119.304 47.8346 120.084 45.9477 121.473 44.5563C122.861 43.165 124.745 42.3832 126.708 42.3826"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M117.796 127.731C116.898 127.088 116.167 126.239 115.663 125.256C115.159 124.273 114.897 123.183 114.898 122.078V49.3283C114.898 48.4157 115.078 47.5121 115.426 46.669C115.775 45.8262 116.286 45.0601 116.93 44.4151C117.574 43.7698 118.339 43.2586 119.181 42.9098C120.023 42.561 120.925 42.3819 121.835 42.3826H127.206"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.203 129.025H121.836C120.388 129.028 118.977 128.574 117.802 127.728"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.636 42.3826C152.634 43.865 152.046 45.2864 150.999 46.3343C149.952 47.3825 148.533 47.9714 147.054 47.9724H133.175C131.695 47.9724 130.276 47.3835 129.229 46.3353C128.183 45.2867 127.595 43.865 127.595 42.3826H152.636Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M153.455 69.7209H128.997C127.904 69.7209 126.855 69.2854 126.082 68.5108C125.308 67.7359 124.874 66.6852 124.874 65.5894V56.5848C124.874 55.489 125.308 54.4383 126.082 53.6634C126.855 52.8886 127.904 52.4534 128.997 52.4534H153.455C154.548 52.4534 155.597 52.8886 156.371 53.6634C157.144 54.4383 157.578 55.489 157.578 56.5848V65.591C157.578 66.6862 157.143 67.7366 156.37 68.5111C155.597 69.2854 154.549 69.7206 153.455 69.7209Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M153.455 95.3957H128.997C127.904 95.3957 126.855 94.9605 126.082 94.1856C125.308 93.4107 124.874 92.36 124.874 91.2646V82.2596C124.874 81.1638 125.308 80.1131 126.082 79.3382C126.855 78.5637 127.904 78.1282 128.997 78.1282H153.455C154.548 78.1282 155.597 78.5637 156.371 79.3382C157.144 80.1131 157.578 81.1638 157.578 82.2596V91.2658C157.578 92.3613 157.143 93.4114 156.37 94.1859C155.597 94.9605 154.549 95.3954 153.455 95.3957Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M134.577 121.071H128.997C127.904 121.071 126.855 120.636 126.082 119.861C125.308 119.086 124.874 118.035 124.874 116.94V107.935C124.874 106.839 125.308 105.788 126.082 105.014C126.855 104.239 127.904 103.803 128.997 103.803H153.455C154.548 103.803 155.597 104.239 156.371 105.014C157.144 105.788 157.578 106.839 157.578 107.935V116.941C157.579 117.493 157.468 118.039 157.253 118.547"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M107.72 87.4473H114.898H117.151H119.3H124.876H127.596"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.76 113.956C143.413 113.669 140.071 113.057 138.129 113.528C136.585 113.906 133.307 116.218 133.912 119.395C134.031 119.989 134.255 120.556 134.574 121.071C134.747 121.353 134.937 121.623 135.145 121.88C138.702 126.283 144.322 127.768 148.022 128.06L148.762 128.816C150.56 130.664 155.118 135.339 156.33 136.644C156.33 136.644 159.866 150.529 163.776 154.447C169.067 159.751 172.096 161.263 175.496 161.771"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M146.605 114.047C146.412 114.06 146.234 114.072 146.071 114.085"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M149.752 114.146C149.53 114.106 149.318 114.079 149.1 114.057C148.369 113.986 147.633 113.976 146.9 114.029"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M150.429 114.287C150.325 114.26 150.224 114.238 150.122 114.215"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M151.129 114.49C150.972 114.435 150.816 114.389 150.659 114.349"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M167.306 124.948C165.165 124.009 163.125 122.852 161.22 121.495C159.883 120.591 158.514 119.598 157.212 118.601C156.239 117.854 155.303 117.104 154.453 116.384C153.541 115.603 152.498 114.99 151.372 114.572L151.151 114.5"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M161.22 121.498C161.22 121.498 161.706 121.591 162.43 121.683C163.927 121.876 166.456 122.079 167.862 121.498"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M146.794 114.032C146.002 114.902 142.178 117.815 142.67 121.492"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M133.912 119.396C135.354 120.478 138.898 121.135 140.286 120.355C140.286 120.355 141.103 116.189 142.937 114.802"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M209.682 180.092C209.682 180.092 209.682 176.485 207.088 170.018C204.909 164.576 194.167 148.291 190.825 138.969C187.612 130.002 183.076 118.82 180.184 112.663C180.071 112.414 179.957 112.178 179.847 111.947C176.983 105.969 171.733 92.1017 168.39 86.3613C165.048 80.6209 162.439 79.8223 162.439 79.8223"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M169.712 169.641L169.676 169.629V169.635C169.712 169.78 170.523 172.953 171.063 175.864C171.378 177.251 171.528 178.67 171.511 180.092"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M139.236 139.824C139.138 140.321 139.097 140.827 139.113 141.334C139.113 141.491 139.123 141.648 139.135 141.804C139.237 142.939 139.655 144.022 140.341 144.932C141.716 146.755 144.04 149.657 145.365 150.278C145.365 150.278 158.489 166.731 164.542 168.312C168.509 169.349 169.482 169.592 169.678 169.635C169.689 169.638 169.7 169.64 169.712 169.641C169.716 169.642 169.72 169.642 169.724 169.641"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M139.113 141.804C139.113 141.804 132.218 141.007 128.513 139.824C128.513 139.824 122.611 138.275 120.966 137.564C120.966 137.564 110.654 133.73 108.048 132.22C105.443 130.71 106.674 124.382 111.89 125.895C114.963 126.784 117.67 127.684 117.796 127.728"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M120.156 131.03C120.156 131.03 119.794 132.66 119.705 133.475"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M129.67 132.568C129.67 132.568 129.308 135.12 129.219 135.935"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M169.676 169.629C169.676 169.629 171.377 169.656 172.457 169.629L171.066 175.862"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.585 108.372C114.585 108.372 107.299 106.545 104.872 108.372C102.444 110.198 102.441 115.671 106.996 116.431C111.55 117.19 114.898 117.765 114.898 117.765"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M141.087 129.025C140.703 129.759 140.42 130.541 140.243 131.35C140.128 131.85 140.055 132.359 140.026 132.872"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M129.458 129.025C129.458 129.025 138.352 130.966 140.025 131.338"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M136.772 87.5267C136.772 88.2509 136.558 88.9585 136.156 89.5605C135.755 90.1623 135.184 90.6313 134.516 90.9084C133.849 91.1855 133.114 91.2578 132.405 91.1166C131.697 90.9754 131.046 90.6269 130.535 90.115C130.023 89.6031 129.676 88.951 129.534 88.2409C129.393 87.5308 129.466 86.7948 129.742 86.126C130.018 85.4569 130.486 84.8853 131.087 84.4829C131.688 84.0803 132.394 83.8655 133.117 83.8652C133.597 83.8652 134.072 83.9598 134.516 84.1439C134.959 84.3277 135.362 84.5975 135.702 84.9375C136.041 85.2776 136.31 85.6811 136.494 86.1254C136.678 86.5697 136.772 87.0458 136.772 87.5267Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M170.532 61.0039H162.439H157.58H153.729"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M148.204 64.7461C150.223 64.7461 151.86 63.1061 151.86 61.0836C151.86 59.0611 150.223 57.4211 148.204 57.4211C146.185 57.4211 144.548 59.0611 144.548 61.0836C144.548 63.1061 146.185 64.7461 148.204 64.7461Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M185.878 112.661H180.184H162.439H157.58H153.729"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.76 113.955C145.129 114.035 145.35 114.088 145.35 114.088C145.591 114.106 145.833 114.106 146.073 114.088C146.239 114.078 146.417 114.065 146.607 114.051C146.669 114.051 146.73 114.045 146.795 114.038C146.832 114.038 146.867 114.038 146.905 114.032C147.638 113.981 148.374 113.99 149.105 114.06C149.314 114.082 149.532 114.112 149.757 114.149C149.879 114.171 150.002 114.196 150.127 114.222C150.229 114.243 150.33 114.268 150.434 114.294C150.511 114.313 150.588 114.334 150.664 114.356C150.821 114.398 150.977 114.445 151.134 114.497C151.141 114.5 151.148 114.502 151.156 114.503C151.228 114.527 151.3 114.552 151.372 114.58V114.577C151.652 114.09 151.817 113.546 151.853 112.985C151.89 112.425 151.797 111.863 151.582 111.345C151.367 110.826 151.036 110.363 150.615 109.993C150.193 109.623 149.692 109.355 149.151 109.21C148.609 109.065 148.042 109.047 147.492 109.156C146.942 109.266 146.425 109.501 145.98 109.842C145.535 110.184 145.175 110.624 144.927 111.128C144.679 111.632 144.55 112.186 144.55 112.747C144.551 113.159 144.622 113.568 144.76 113.955Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M100.615 84.3629H99.1259C98.5769 84.3629 98.3006 83.5239 98.6919 83.0345L99.7431 81.7067L96.9688 78.2139L95.9163 79.5389C95.5263 80.028 94.8634 79.6839 94.8634 78.9888V77.116H90.9381V78.9917C90.9381 79.6861 90.2747 80.0311 89.8847 79.5417L88.8322 78.2168L86.0578 81.7067L87.1103 83.0345C87.5003 83.5239 87.2241 84.3629 86.6763 84.3629H85.1859V89.3012H86.6763C87.2253 89.3012 87.5019 90.1374 87.1103 90.6296L86.0578 91.9552L88.8322 95.448L89.8847 94.1224C90.2747 93.6308 90.9381 93.9774 90.9381 94.6703V96.5453H94.8634V94.6703C94.8634 93.9781 95.5263 93.6308 95.9163 94.1224L96.9688 95.448L99.7431 91.9552L98.6906 90.6296C98.3006 90.1374 98.5769 89.3012 99.1247 89.3012H100.613V84.3629H100.615Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M95.2281 86.8326C95.2281 88.4494 94.185 89.7627 92.9022 89.7627C91.6197 89.7627 90.5728 88.4494 90.5728 86.8326C90.5728 85.2155 91.6159 83.8987 92.9022 83.8987C94.1884 83.8987 95.2281 85.2118 95.2281 86.8326Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M186.154 57.2862C185.563 57.0182 184.915 56.8986 184.267 56.9384C182.849 57.0304 181.617 58.0489 180.774 59.5216C179.892 61.1256 179.489 62.9493 179.611 64.7764C179.617 64.8713 179.623 64.9699 179.632 65.0663"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M189.833 63.7833C189.833 63.6875 189.828 63.5926 189.821 63.4934C189.739 61.9164 189.215 60.3945 188.308 59.1027C188.029 58.7154 187.706 58.3625 187.345 58.051"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M189.833 63.7834L192.872 63.5864C192.866 63.4913 192.866 63.3958 192.86 63.2965C192.728 60.7912 191.897 58.373 190.463 56.3166C188.815 54.0415 186.491 52.6789 184.006 52.842C181.615 52.9992 179.555 54.7027 178.211 57.1748C176.953 59.5715 176.388 62.2721 176.578 64.9728C176.584 65.0708 176.593 65.1663 176.6 65.2627L179.638 65.0664"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M187.345 58.0518L187.495 57.775C187.593 57.5824 187.631 57.3645 187.604 57.1501C187.576 56.9353 187.485 56.7343 187.341 56.5724C187.281 56.5054 187.205 56.4547 187.119 56.4253C187.034 56.3959 186.943 56.3887 186.854 56.4043C186.765 56.42 186.682 56.4582 186.612 56.5151C186.542 56.5721 186.488 56.646 186.454 56.7299L186.154 57.2866L184.924 59.5552C184.766 59.4991 184.598 59.476 184.43 59.4876C183.524 59.5464 182.852 60.5859 182.932 61.8069C183.012 63.0282 183.813 63.975 184.718 63.9161C185.623 63.8576 186.296 62.8188 186.216 61.5968C186.194 61.2505 186.11 60.9108 185.967 60.5943L187.345 58.0518Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M184.003 52.8428L184.267 56.9389"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M178.229 57.188L180.451 59.5001"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M190.349 56.397L188.489 58.9771"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M202.065 113.07L203.873 110.77C204.398 110.95 204.967 110.954 205.494 110.781C206.021 110.609 206.478 110.269 206.795 109.813C207.265 109.199 207.555 108.465 207.633 107.695C207.611 107.723 207.59 107.753 207.568 107.784C207.38 108.057 207.128 108.28 206.834 108.434C206.54 108.589 206.213 108.669 205.882 108.669C205.55 108.669 205.223 108.589 204.93 108.434C204.636 108.28 204.384 108.057 204.195 107.784C203.742 107.162 203.498 106.412 203.498 105.643C203.498 104.873 203.742 104.123 204.195 103.501C204.217 103.472 204.241 103.445 204.268 103.421C203.599 103.556 203.004 103.933 202.598 104.482C202.211 105.009 201.943 105.613 201.813 106.254C201.683 106.896 201.695 107.557 201.846 108.193L200.038 110.493"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M198.004 113.07L195.435 116.332L195.462 116.366C195.198 116.378 194.94 116.449 194.707 116.574C194.473 116.7 194.271 116.876 194.115 117.09C193.746 117.598 193.547 118.21 193.547 118.838C193.547 119.466 193.746 120.078 194.115 120.586C194.269 120.809 194.475 120.991 194.715 121.116C194.954 121.242 195.221 121.308 195.492 121.308C195.762 121.308 196.029 121.242 196.268 121.116C196.508 120.991 196.714 120.809 196.868 120.586C197.238 120.094 197.437 119.493 197.436 118.877L197.464 118.91L199.109 116.823L200.032 115.648"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M200.032 110.493L198.224 108.193C198.375 107.557 198.386 106.895 198.255 106.254C198.125 105.613 197.857 105.008 197.469 104.482C197.064 103.934 196.471 103.556 195.805 103.421C195.828 103.446 195.851 103.473 195.872 103.501C196.326 104.122 196.571 104.872 196.571 105.643C196.571 106.412 196.326 107.163 195.872 107.784C195.684 108.057 195.432 108.28 195.138 108.434C194.845 108.589 194.518 108.669 194.187 108.669C193.856 108.669 193.529 108.589 193.236 108.434C192.942 108.28 192.691 108.057 192.502 107.784C192.478 107.753 192.459 107.723 192.438 107.695C192.516 108.465 192.804 109.198 193.273 109.813C193.591 110.269 194.048 110.609 194.575 110.782C195.103 110.954 195.672 110.95 196.197 110.77L198.006 113.07L200.032 115.647L202.601 118.908L202.625 118.875C202.625 119.491 202.824 120.091 203.192 120.584C203.347 120.807 203.552 120.988 203.792 121.114C204.032 121.24 204.299 121.306 204.569 121.306C204.84 121.306 205.106 121.24 205.346 121.114C205.586 120.988 205.792 120.807 205.946 120.584C206.317 120.077 206.517 119.464 206.517 118.836C206.517 118.207 206.317 117.595 205.946 117.088C205.791 116.874 205.589 116.697 205.357 116.572C205.124 116.446 204.866 116.375 204.602 116.363L204.626 116.329L202.06 113.068L200.032 110.493Z"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M198.004 113.07L199.109 116.822"
          stroke="#006B99"
          strokeWidth="3.704"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_1495">
          <rect width="300" height="201" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PinkSvg;
